import React from 'react'

const SliderArrowLeft = () => (
  <svg className="icon">
    <use
      xlinkHref={`/Static/Images/icons.svg?=${
        process.env.BUILD_VERSION_ID
      }#icon--slider-arrow-left`}
    />
  </svg>
)

export default SliderArrowLeft
